
import React ,{Component} from 'react';
import { bindActionCreators } from 'redux';
import { withRouter }         from 'react-router-dom';
import { connect }            from 'react-redux';
import {  message, Divider } from "antd";

import CreateJobsReport from './EachActiveJobs/eachActiveJobs';

import "./activeJobs.scss";
class ActiveJobsList extends Component{
    constructor(props) {
        super(props)

        let activeJobsReportList=[
            {
                name:'10 GB',
                storage: '10 GB',
                source: 'wasabi-rick',
                destination: 'aws',
                percentage: 63,
                action: 'active'
            },
            {
                name:'30 GB',
                storage: '30 GB',
                source: 'wasabi-rick',
                destination: 'azure',
                percentage: 80,
                action: 'active'
            },
            {
                name:'100 GB',
                storage: '100 GB',
                source: 'wasabi-rick',
                destination: 'genericS3',
                percentage: 20,
                action: 'pause'
            },

        ];
        this.state = {
            activeJobsReport: activeJobsReportList,
        }

    }
    render(){
        const jobsReportTableHeader = <ul>
                                        <li>Name</li>
                                        <li>Storage</li>
                                        <li>Source account</li>
                                        <li>Destination</li>
                                        <li>% Transfered</li>
                                        <li>Actions</li>
                                    </ul>

        const ReportList = this.state.activeJobsReport.map((rl,index)=>{
            return(
                <div>
                     <Divider/>
                    <CreateJobsReport 
                        key = {index}
                        name = {rl.name}
                        storage = {rl.storage}
                        source = {rl.source}
                        destination = {rl.destination}
                        percentage = {rl.percentage}
                        action = {rl.action}
                    />
                </div>
            )
        })
        return(
            <div className="active-jobs-wrapper">
                <div className="header">
                    <h3>Active Jobs</h3>
                </div>
                <div className="table-header">
                    {jobsReportTableHeader}
                </div>
                <div>
                    {ReportList}
                </div>
            </div>
        )
    }
}

export default withRouter(
    connect(
    //   mapStateToProps,
    //   mapDispatchToProps
    )(ActiveJobsList)
  );